import { render, staticRenderFns } from "./orderProducts.vue?vue&type=template&id=172a26a5&scoped=true"
import script from "./orderProducts.vue?vue&type=script&lang=js"
export * from "./orderProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172a26a5",
  null
  
)

export default component.exports